<template>
  <div class="content">
    <div class="card red">
      <h2 class="card-h2" style="padding: 1em">NOTE: Data is available from 2006 to June 1, 2023.</h2>
    </div>
    <PageTitle :results-filters="resultsFilters"></PageTitle>

    <div class="well collisions-filters">
      <h2 class="well-title collisions-filters-title">
        <span>Filter collisions</span>
      </h2>
      <div class="well-content">
        <FilterDate :default-option="{ key: '2023', label: '2023' }"></FilterDate>
        <div class="filter-map">
          <span class="filter-map-label">Limit results to map area?</span> <FilterMapActive></FilterMapActive>
        </div>
        <FilterSubmitButton :routeName="'collisions'"
                            :routeParams="routeParams"
                            v-bind:class="[{'is-loading': isLoading}]"></FilterSubmitButton>
      </div>
    </div>

    <div class="l-grid l-grid-small">
      <Who></Who>
      <DamageCosts :getter="'collisionsView/damageCosts/get'"
                 :title="'Economic costs'"
                 :bar-color="this.$store.getters.green.light.a"
                 :chart-height="300"></DamageCosts>

      <Weather :card-color="'blue'"
               :card-icon="'cloud'"
               :getter="'collisionsView/weather/get'"
               :table-color="'blue'"
               :title="'Weather'"
               :bar-color="this.$store.getters.blue.light.a"
               :chart-height="380"
               :x-min-axes-rotation="75"></Weather>

      <RoadConditions :card-color="'orange'"
                      :getter="'collisionsView/roadConditions/get'"
                      :table-color="'orange'"
                      :title="'Road conditions'"
                      :bar-color="this.$store.getters.orange.light.a"
                      :chart-height="380"></RoadConditions>

      <LightConditions :card-color="'yellow'"
                       :card-icon="'wb_incandescent'"
                       :getter="'collisionsView/lightConditions/get'"
                       :table-color="'yellow'"
                       :title="'Light conditions'"
                       :bar-color="this.$store.getters.yellow.light.a"
                       :chart-height="310"></LightConditions>

      <CollisionTypes :card-color="'purple'"
                      :card-icon="'call_split'"
                      :getter="'collisionsView/collisionTypes/get'"
                      :table-color="'purple'"
                      :title="'Collision types'"
                      :bar-color="this.$store.getters.purple.light.a"
                      :chart-height="310"></CollisionTypes>

      <JunctionTypes :card-color="'teal'"
                     :getter="'collisionsView/junctionTypes/get'"
                     :table-color="'teal'"
                     :title="'Junction types'"
                     :bar-color="this.$store.getters.teal.light.b"
                     :chart-height="520"
                     :x-min-axes-rotation="80"></JunctionTypes>

      <AddressTypes :card-color="'teal'"
              :getter="'collisionsView/addressTypes/get'"
              :table-color="'teal'"
              :title="'Address types'"
              :bar-color="this.$store.getters.teal.light.b"></AddressTypes>
    </div>

    <CollisionMap :map-active="mapActive"></CollisionMap>
    <Collision></Collision>
  </div>
</template>

<script>
import FilterDate from '@/components/FilterDate'
import FilterMapActive from '@/components/FilterMapActive'
import FilterSubmitButton from '@/components/FilterSubmitButton'

import BarChartWithTable from '@/components/barCharts/BarChartWithTable'
import DamageCosts from '@/components/barCharts/DamageCosts'
import Collision from './collisions/Collision'
import CollisionMap from './collisions/CollisionMap'
import PageTitle from './collisions/PageTitle'
import Who from './collisions/Who'

export default {
  name: 'collisions',

  components: {
    'FilterDate': FilterDate,
    'FilterMapActive': FilterMapActive,
    'FilterSubmitButton': FilterSubmitButton,
    'PageTitle': PageTitle,

    'AddressTypes': BarChartWithTable,
    'JunctionTypes': BarChartWithTable,
    'CollisionTypes': BarChartWithTable,
    'LightConditions': BarChartWithTable,
    'RoadConditions': BarChartWithTable,
    'Weather': BarChartWithTable,
    'DamageCosts': DamageCosts,
    'Collision': Collision,
    'CollisionMap': CollisionMap,
    'Who': Who
  },

  mounted: function () {
    this.$store.dispatch('collisionsView/resetResults')
    this.$store.dispatch('collisionsView/setFilters')
    this.$store.dispatch('collisionsView/fetchAll', this.filters)
    document.getElementById('app').classList.add('collisions')
  },

  computed: {
    filters () {
      return this.$store.getters['collisionsView/filters']
    },

    routeParams () {
      return {
        sd: this.filters.startDate,
        ed: this.filters.endDate,
        m: this.filters.map.active,
        nelat: this.filters.map.bounds.ne.lat,
        nelng: this.filters.map.bounds.ne.lng,
        swlat: this.filters.map.bounds.sw.lat,
        swlng: this.filters.map.bounds.sw.lng
      }
    },

    resultsFilters () {
      return this.$store.getters['collisionsView/resultsFilters']
    },

    isLoading () {
      return (this.$store.getters['collisionsView/collisionLocations/get'].length > 0) ? 0 : 1
    },

    mapActive () {
      return this.$store.getters['collisionsView/filters'].map.active
    }
  },

  watch: {
    $route: function (to, from) {
      this.$store.dispatch('collisionsView/resetResults')
      this.$store.dispatch('collisionsView/fetchAll', this.filters)
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'collisions') {
      document.getElementById('app').classList.remove('collisions', 's-map-collapsed', 's-map-default', 's-map-medium', 's-map-full')
    }
    next()
  }
}
</script>

<style lang="scss">
@import "./src/sass/text";
@import "./src/sass/well";
@import "./src/sass/views/collisions";
</style>



// WEBPACK FOOTER //
// Collisions.vue?5a8dbe2b